import { themeWithoutDir as theme } from '~/modules/App/withRootTheme';

export const PillChartColors = {
  overEstimation: theme.palette.error.dark,
  underEstimation: theme.palette.success.dark,
  onTrack: theme.palette.information.dark
};
